var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemparature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c48e4e",
    d: "M50.328 69.384a7.7 7.7 0 0 0 1.279 1.39l-20.522-7.842-5.339-2.058s1.446.167 3.671.5c5.95.946 17.518 3.338 20.911 8.01m41.544 3.392H61.728c-1.835-.111-3.559.056-5.228-.111 0 0 5.395-10.678 11.846-14.46a8.7 8.7 0 0 1 2.058-1.001s.056 0 .111-.056c1.056-.222 12.012-2.781 17.797 6.674 4.729 7.731 3.56 8.954 3.56 8.954",
    "data-original": "#c48e4e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc466",
    d: "M91.872 72.776v18.131H4V73.166h10.845s1.891-5.506 9.566-11.29c.39-.334.89-.668 1.335-1.001 0 0 1.446.167 3.671.5 5.951.946 17.519 3.337 20.912 8.009a7.7 7.7 0 0 0 1.279 1.39c1.502 1.39 3.114 1.835 4.894 1.891 1.669.167 3.392 0 5.228.111z",
    "data-original": "#ffc466"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8effe",
    d: "M53.516 35.881c4.12 2.588 6.608 7.529 5.527 12.997-.928 4.691-4.686 8.506-9.363 9.499-8.018 1.702-15.059-4.336-15.059-12.048 0-4.424 2.312-8.269 5.78-10.448v-23.85c0-3.181 2.085-6.164 5.201-6.8a6.62 6.62 0 0 1 6.002 1.774 6.63 6.63 0 0 1 1.912 4.646z",
    "data-original": "#c8effe"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.958,
    cy: 46.329,
    r: 5.227,
    fill: "#5fc5ed",
    "data-original": "#5fc5ed"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5a133",
    d: "M34.589 90.907h-4.784c-1.446-1.056-2.391-2.447-3.003-4.06-1.446-4.171.557-8.454.612-8.621.056-.056 2.781-5.784 2.781-9.788 0-2.781-3.893-5.395-5.228-6.062-.223-.111-.445-.278-.557-.5.39-.334.89-.668 1.335-1.001 0 0 1.446.167 3.671.5.556.445 1.113.946 1.668 1.557 1.335 1.446 2.392 3.337 2.392 5.506 0 4.784-2.947 10.956-3.058 11.234-.334.667-3.003 6.841 3.17 9.733.611.278 1.001.834 1.001 1.502",
    "data-original": "#e5a133"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#aa8979",
    d: "M19.654 47.414h-3.807a1.666 1.666 0 1 1 0-3.334h3.807a1.666 1.666 0 1 1 0 3.334",
    "data-original": "#aa8979"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5a133",
    d: "M77.468 72.776h-2.836c-1.446-1.613-7.509-8.676-6.34-14.46 0-.056 0-.056.056-.111a8.7 8.7 0 0 1 2.058-1.001s.056 0 .111-.056c.722.278 1.223 1.057 1.056 1.836-.778 3.837 3.893 9.788 5.729 11.79.555.556.611 1.39.166 2.002",
    "data-original": "#e5a133"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#5fc5ed",
    d: "M46.962 42.77a1.666 1.666 0 0 1-1.667-1.667V24.1a1.667 1.667 0 1 1 3.335 0v17.002c0 .921-.744 1.668-1.668 1.668",
    "data-original": "#5fc5ed"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e14e2b",
    d: "M67.4 13.651h-6.67a1.666 1.666 0 1 1 0-3.334h6.67a1.666 1.666 0 1 1 0 3.334m-2.227 6.669H60.73a1.666 1.666 0 1 1 0-3.334h4.443a1.666 1.666 0 1 1 0 3.334m2.227 6.67h-6.67a1.666 1.666 0 1 1 0-3.334h6.67a1.666 1.666 0 1 1 0 3.334",
    "data-original": "#e14e2b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemparature);
export default __webpack_public_path__ + "static/media/temparature.bf64fea75f6880fd2653c0deed5680a3.svg";
export { ForwardRef as ReactComponent };